import { useElement } from '@atomify/hooks';
import { BPDInput } from '@atoms/form-elements';
import { ModalCloseConfirmationPopupElement } from '@atoms/modal-close-confirmation-popup/modal-close-confirmation-popup';
import { PagesProps } from '@atoms/pages';
import { AreaSubscriptionListElement } from '@features/area-subscription/types';
import { Modal } from '@molecules/modal';

export const attachAreaSubscriptionModalElements = () => {
    const modal = useElement<Modal>('bpd-modal', { as: 'modal' });
    const modalCloseCta = useElement<HTMLButtonElement>('[js-hook-modal-trigger]', {
        as: 'modalCloseCta',
    });
    const modalCloseConfirmation = useElement<ModalCloseConfirmationPopupElement>(
        'modal-close-confirmation-popup',
        { as: 'modalCloseConfirmation' },
    );

    const bpdPages = useElement<PagesProps>('bpd-pages', { as: 'bpdPages' });

    const step1Title = useElement<HTMLParagraphElement>(
        '[js-hook-area-subscription-modal-step-1-title]',
        { as: 'step1Title' },
    );
    const step1Description = useElement<HTMLParagraphElement>(
        '[js-hook-area-subscription-modal-step-1-description]',
        { as: 'step1Description' },
    );
    const areaOnlyToggle = useElement<BPDInput>(
        '[js-hook-area-subscription-subscribe-area-only-toggle]',
        { as: 'areaOnlyToggle' },
    );
    const areaOnlyToggleInput = useElement<HTMLInputElement>(
        '[js-hook-area-subscription-subscribe-area-only-toggle-input]',
        { as: 'areaOnlyToggleInput' },
    );
    const areaOnlyToggleLabel = useElement<HTMLSpanElement>(
        '[js-hook-area-subscription-subscribe-area-only-toggle-label]',
        { as: 'areaOnlyToggleLabel' },
    );

    const step1SubscribedList = useElement<AreaSubscriptionListElement>(
        '[js-hook-area-subscription-modal-step-1-subscribed-list]',
        { as: 'step1SubscribedList' },
    );
    const step1AvailableList = useElement<AreaSubscriptionListElement>(
        '[js-hook-area-subscription-modal-step-1-available-list]',
        { as: 'step1AvailableList' },
    );

    const areaSubscriptionForm = useElement<HTMLDivElement>(
        '[js-hook-area-subscription-modal-step-2-form]',
        { as: 'areaSubscriptionForm' },
    );

    const step3Title = useElement<HTMLParagraphElement>(
        '[js-hook-area-subscription-modal-step-3-title]',
        { as: 'step3Title' },
    );
    const step3Confirmation = useElement<HTMLDivElement>(
        '[js-hook-area-subscription-modal-step-3-confirmation]',
        { as: 'step3Confirmation' },
    );
    const step3Advantages = useElement<HTMLDivElement>(
        '[js-hook-area-subscription-modal-step-3-advantages]',
        { as: 'step3Advantages' },
    );
    const step3ListIntroTitle = useElement<HTMLParagraphElement>(
        '[js-hook-area-subscription-modal-step-3-list-intro-title]',
        { as: 'step3ListIntroTitle' },
    );
    const step3ListIntroContent = useElement<HTMLParagraphElement>(
        '[js-hook-area-subscription-modal-step-3-list-intro-content]',
        { as: 'step3ListIntroContent' },
    );
    const step3AvailableList = useElement<AreaSubscriptionListElement>(
        '[js-hook-area-subscription-modal-step-3-available-list]',
        { as: 'step3AvailableList' },
    );

    const step4Title = useElement<HTMLParagraphElement>(
        '[js-hook-area-subscription-modal-step-4-title]',
        { as: 'step4Title' },
    );
    const step4Confirmation = useElement<HTMLParagraphElement>(
        '[js-hook-area-subscription-modal-step-4-confirmation]',
        { as: 'step4Confirmation' },
    );
    const step4Advantages = useElement<HTMLParagraphElement>(
        '[js-hook-area-subscription-modal-step-4-advantages]',
        { as: 'step4Advantages' },
    );

    const navigationCta = useElement<HTMLDivElement>('[js-hook-area-subscription-navigation-cta]', {
        as: 'navigationCta',
    });
    const navigationHelperText = useElement<HTMLParagraphElement>(
        '[js-hook-area-subscription-navigation-helper-text]',
        { as: 'navigationHelperText' },
    );
    const navigationCheckmark = useElement<HTMLSpanElement>(
        '[js-hook-area-subscription-navigation-checkmark]',
        { as: 'navigationCheckmark' },
    );

    return {
        modal,
        modalCloseCta,
        modalCloseConfirmation,
        bpdPages,
        step1Title,
        step1Description,
        areaOnlyToggle,
        areaOnlyToggleInput,
        areaOnlyToggleLabel,
        step1SubscribedList,
        step1AvailableList,
        areaSubscriptionForm,
        step3Title,
        step3Confirmation,
        step3Advantages,
        step3ListIntroTitle,
        step3ListIntroContent,
        step3AvailableList,
        step4Title,
        step4Confirmation,
        step4Advantages,
        navigationCta,
        navigationHelperText,
        navigationCheckmark,
    };
};
